import { loadSdk } from "vim-os-js-browser";
import { socketActions, socketSubActions } from "../../../helper/Websocket";
import { signInWithCustomTokenCustom } from "../../../actions/firebase";
import { store } from "../../../redux/store";
import { saveusercredentials } from "../../../redux/actions/auth.action";
import { fetchMutation, getProviderData, refreshReduxStore } from "../../../actions";
import { INVITE_PATIENT } from "../../../viewpages/newpages/InvitePatientModdule/invitePatientAction";
import { ShowAlert } from "../../newCreateContent/CreateContentAlert";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import { UPDATE_ITEM_VIEWED_STATUS } from "../../../viewpages/newpages/profileModule/actions/profileQueries";
import { isDevelopmentEnvironment } from "../../newProviderApp/actions/helpers";
import { customToken } from "../../../api/onboarding";

export async function initVimOS(history, errorCallback = () => { }) {
   try {
      const vimOS = await loadSdk();
      if (vimOS) {
         // vimOS.hub.setActivationStatus("ENABLED");
         window.vimOS = vimOS;
         exchangeToken(vimOS, history, errorCallback);
      }
   } catch (error) {
      errorCallback();
      console.error("Failed to initialize VimOS SDK", error);
   }
}

export const exchangeToken = async (payload, history, errorCallback) => {
   try {
      const response = await customToken({
         sessionContext: payload.sessionContext,
      });
      if (response) {
         signInWithCustomTokenCustom(
            response.customToken,
            () => {
               let userData = { user: response.userData };
               getProviderData(userData, false, () => { }, true);
               store.dispatch(saveusercredentials(userData));
               refreshReduxStore();
               setTimeout(() => {
                  history.push("/vim");
               }, 1000);
            },
            (error) => {
               console.log(error);
            }
         );
      } else {
         errorCallback();
      }
   } catch (error) {
      errorCallback();
   }
};

export const invitePatientEhr = async (patientDetailsEpic, callback = () => { }, errorCallback = () => { }) => {
   const loggedInProviderDetails = store.getState().auth.loggedInProviderDetails;
   let enterpriseId = loggedInProviderDetails.enterpriseInfo.id;
   let enterpriseName = loggedInProviderDetails.enterpriseInfo.name;

   let payload = {
      noNotification: true,
      patient: {
         name: {
            fullName: patientDetailsEpic.name,
         },
         contactInformation: {
            email: new Date().getTime().toString() + "@playbackhealth.com",
            mobileNumber: null,
         },
         dateOfBirth: patientDetailsEpic.dob,
         mrn: patientDetailsEpic.mrn,
         healthSystems: [
            {
               id: enterpriseId,
               name: enterpriseName,
               role: "patient",
               patientIdentifiers: [
                  {
                     type: "MRN",
                     number: patientDetailsEpic.mrn,
                     authority: "MRN",
                  },
                  { type: "EPI", number: patientDetailsEpic.mrn, authority: "MRN" },
                  { type: "id", number: patientDetailsEpic.id, authority: "EPIC" },
                  { type: "vimId", number: patientDetailsEpic.vimId, authority: "VIM" },
               ],
            },
         ],
      },
   };

   fetchMutation(
      INVITE_PATIENT,
      payload,
      (data) => {
         callback(data.data.addPatient.user.id);
      },
      (error) => {
         errorCallback();
         ShowAlert(errorToDisplay(error), "error");
      }
   );
};

export const formatizeJson = (notesArray) => {
   return formatEncounterPayload(
      notesArray.map((note) => {
         return JSON.parse(
            JSON.stringify(note, (key, value) => {
               if (Array.isArray(value)) {
                  return value.join("  \n"); // Convert arrays to space-separated strings
               }
               return value;
            })
         );
      })
   );
};
export const addLogs = (noteId) => {
   fetchMutation(UPDATE_ITEM_VIEWED_STATUS, {
      options: {
         eventName: "noteCopiedToEmr",
         noteId: noteId,
      },
   });
};

function filterSafeWords(sentence) {
   if (!sentence) return "";
   const safeWordRegex = /^[a-zA-Z0-9~`!@#$%^&*()\-_+={[}\]|\\;:'",<>.\/?\n\t\r°]+$/;
   return sentence
      .split(/([^\S\r\n]+)/) // split only on space and tab, NOT \n
      .filter((word) => safeWordRegex.test(word) || word === "\n")
      .join(" ");
}

function normalizeText(str) {
   return str
      ? filterSafeWords(str)
         .replace(/[\u2018\u2019]/g, "'") // Curly apostrophes (‘ ’) → Straight apostrophe (')
         .replace(/[\u201C\u201D]/g, '"') // Curly quotes (“ ”) → Straight quotes (")
         .replace(/[\u2013\u2014]/g, "-") // En dash & Em dash (– —) → Hyphen (-)
         .replace(/\u2026/g, "...") // Ellipsis (…) → Three dots (...)
         .replace(/°/g, "") // Explicitly remove degree symbol
         .normalize("NFKD") // Decomposes accented characters (e.g., é → e, ñ → n)
         .replace(/[\u0300-\u036f]/g, "") // Removes any remaining diacritic marks
      : undefined;
}

function formatEncounterPayload(data) {
   data = data[0];
   const formattedPayload = {
      subjective: {
         generalNotes: normalizeText(data?.subjective?.generalNotes),
         chiefComplaintNotes: normalizeText(data?.subjective?.chiefComplaintNotes),
         historyOfPresentIllnessNotes: normalizeText(data?.subjective?.historyOfPresentIllnessNotes),
         reviewOfSystemsNotes: normalizeText(data?.subjective?.reviewOfSystemsNotes),
      },
      objective: {
         generalNotes: normalizeText(data?.objective?.generalNotes),
         physicalExamNotes: normalizeText(data?.objective?.physicalExamNotes),
      },
      assessment: {
         generalNotes: normalizeText(data?.assessment?.generalNotes),
      },
      plan: {
         generalNotes: normalizeText(data?.plan?.generalNotes),
      },
      patientInstructions: {
         generalNotes: normalizeText(data?.patientInstructions?.generalNotes),
      },
   };
   return formattedPayload;
}

export function removeUndefinedProperties(obj) {
   if (typeof obj !== "object" || obj === null) {
      return obj;
   }

   const result = {};

   for (const [key, value] of Object.entries(obj)) {
      if (typeof value === "object" && value !== null) {
         const nestedResult = removeUndefinedProperties(value);
         if (Object.keys(nestedResult).length > 0) {
            result[key] = nestedResult;
         }
      } else if (value !== undefined) {
         result[key] = value;
      }
   }

   return result;
}

export const validateData = (canUpdateNotes, data) => {
   const formattedPayload = {
      subjective: {
         generalNotes: canUpdateNotes?.details?.subjective?.generalNotes
            ? normalizeText(data?.subjective?.generalNotes)
            : undefined,
         chiefComplaintNotes: canUpdateNotes?.details?.subjective?.chiefComplaintNotes
            ? normalizeText(data?.subjective?.chiefComplaintNotes)
            : undefined,
         historyOfPresentIllnessNotes: canUpdateNotes?.details?.subjective?.historyOfPresentIllnessNotes
            ? normalizeText(data?.subjective?.historyOfPresentIllnessNotes)
            : undefined,
         reviewOfSystemsNotes: canUpdateNotes?.details?.subjective?.reviewOfSystemsNotes
            ? normalizeText(data?.subjective?.reviewOfSystemsNotes)
            : undefined,
      },
      objective: {
         generalNotes: canUpdateNotes?.details?.objective?.generalNotes
            ? normalizeText(data?.objective?.generalNotes)
            : undefined,
         physicalExamNotes: canUpdateNotes?.details?.objective?.physicalExamNotes
            ? normalizeText(data?.objective?.physicalExamNotes)
            : undefined,
      },
      assessment: {
         generalNotes: canUpdateNotes?.details?.assessment?.generalNotes
            ? normalizeText(data?.assessment?.generalNotes)
            : undefined,
      },
      plan: {
         generalNotes: canUpdateNotes?.details?.plan?.generalNotes
            ? normalizeText(data?.plan?.generalNotes)
            : undefined,
      },
      patientInstructions: {
         generalNotes: canUpdateNotes?.details?.patientInstructions?.generalNotes
            ? normalizeText(data?.patientInstructions?.generalNotes)
            : undefined,
      },
   };
   return formattedPayload;
};

const keyMappings = {
   generalNotes: "General Notes",
   chiefComplaintNotes: "Chief Complaints",
   historyOfPresentIllnessNotes: "History of present illness",
   reviewOfSystemsNotes: "Review of system notes",
   physicalExamNotes: "Physical Exam",
   subjective: "Subjective",
   objective: "Objective",
   assessment: "Assessment",
   plan: "Plan",
   patientInstructions: "Patient Instructions",
};

export const replaceMarkdownKeys = (markdown) => {
   if (!markdown) return "";
   let updatedMarkdown = markdown;

   for (const [originalKey, newLabel] of Object.entries(keyMappings)) {
      updatedMarkdown = updatedMarkdown.replaceAll(originalKey, newLabel);
   }

   return updatedMarkdown;
};

export const objTemplatesDemo = [
   {
      id: isDevelopmentEnvironment ? "f7c4ae9b-49cb-4f5f-bf0e-80632b940fba" : "52d0a7bd-2f3d-4dca-8cca-7b0c79be7878",
      providerId: null,
      enterpriseId: null,
      hospitalId: null,
      isDisable: true,
      title: "SOAP Note ",
      default: false,
      shortDescription: "A standard note that contains a summarized Subjective, Objective Assessment, and Plans.\n",
      description: null,
      documentId: null,
      alreadyExists: false,
      isSampleAvailable: true,
      sample: null,
      __typename: "noteTemplate",
   },

   {
      id: isDevelopmentEnvironment ? "3592aef4-02f2-4b81-931c-45f01929c89f" : "9c5726bb-a990-41c0-8658-b0d1e1eb9660",
      providerId: null,
      enterpriseId: null,
      hospitalId: null,
      isDisable: false,
      title: "Standard Medical Note",
      default: false,
      shortDescription: "A basic note with a summary and bullet point list of action items.",
      description: null,
      documentId: null,
      alreadyExists: false,
      isSampleAvailable: true,
      sample: null,
      __typename: "noteTemplate",
   },
];
